import { useEffect, useRef } from 'react';

export const usePollingEffect = (shouldPoll: boolean, callback: any, interval = 10000) => {
  // Latest-ref: the interval survives re-renders (deps exclude `callback`), so
  // without this every tick replays the closure captured when polling STARTED
  // — e.g. the AI-grading EU poll kept fetching the initial in-progress id set
  // and never saw rows that started grading later (R2-GR02/G68).
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!shouldPoll) return;
    const intervalId = setInterval(() => {
      callbackRef.current?.(() => clearInterval(intervalId));
    }, interval);

    return () => clearInterval(intervalId);
  }, [shouldPoll, interval]);
};
